import React from "react";

export default function Method({ site }) {
  const steps = site.method_steps || [];
  return (
    <section
      data-testid="method-section"
      id="method"
      className="bg-[#050505] border-t border-white/10"
    >
      <div className="px-5 sm:px-8 lg:px-12 py-20 lg:py-28">
        <div className="grid grid-cols-12 gap-y-8 lg:gap-x-10">
          <div className="col-span-12 lg:col-span-4">
            <p className="overline">Метод</p>
            <h2 className="font-display mt-3 text-2xl sm:text-3xl lg:text-4xl uppercase leading-[1] tracking-tight">
              {site.method_title}
              <span className="text-white/35"> — {site.method_subtitle}</span>
            </h2>
          </div>

          <div className="col-span-12 lg:col-span-8">
            <p className="font-mono-jb text-[10px] uppercase tracking-[0.22em] text-white/40 mb-4">
              Пайплайн / 13 шагов
            </p>
            <p className="text-base sm:text-lg leading-[1.55] text-white/85 break-words">
              {steps.map((step, i) => (
                <React.Fragment key={step + i}>
                  <span className="font-display text-white">{step}</span>
                  {i < steps.length - 1 && (
                    <span className="mx-2 text-[#a78bfa]">→</span>
                  )}{" "}
                </React.Fragment>
              ))}
            </p>

            <div className="mt-10 grid grid-cols-3 gap-px bg-white/10 border border-white/10">
              {[
                ["I", "Последовательность"],
                ["II", "Качество"],
                ["III", "Адаптивность"],
              ].map(([code, label]) => (
                <div key={code} className="bg-[#050505] p-4 sm:p-5">
                  <p className="font-mono-jb text-[10px] uppercase tracking-[0.22em] text-[#a78bfa]">
                    Свойство / {code}
                  </p>
                  <p className="mt-2 font-display uppercase text-sm sm:text-base break-words">
                    {label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
